import {
  PERSONAL_INFO_FETCH,
  PERSONAL_INFO_GET,
  GET_ERRORS,
  SET_MESSAGE,
  SET_Info,
} from "../action/types";

const initialState = {
  data: [],
  allData: [],
  message: null,
  error: null,
};

export default function ProfileInfoReducer(state = initialState, action) {
  console.log("profile reducer", action);
  switch (action.type) {
    case PERSONAL_INFO_FETCH:
      return {
        ...state,
        data: action.payload,
      };
    case PERSONAL_INFO_GET:
      return {
        ...state,
        allData: action.payload,
      };
    case SET_MESSAGE:
      return {
        ...state,
        message: action.payload,
      };

    case SET_Info:
      return {
        ...state,
        data: action.payload,
      };
    case GET_ERRORS:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
